module.exports = __webpack_public_path__ + "img/place-1.cadf1635.svg";